import { useEffect, useState } from 'react';
import { getData } from '../../../../utils/api'
import xlbj from '../../../../images/xlbj2.png'
import '../GdjyDetail/index'
import img1 from '../../../../images/111.png'
import img2 from '../../../../images/222.png'
import img3 from '../../../../images/333.png'
import { getApi } from "../../../../utils/getApi";

export const GdjyxjDetailThree = ({ activePage, setActivePage }) => {
    const [dataSource, setDataSource] = useState({});
    const [status, setStatus] = useState(true);
    const [path, setPath] = useState('');


    useEffect(() => {
        setPath(getApi())

        const getList = async () => {
            const res = await getData('/api/user/zhengshu', 'post')
            if (res.data.code == 1) {
                setDataSource(res.data.data[0]);
            }
        }
        if (window.location.search.length > 2) {
            setStatus(false)
        }
        getList()

    }, [])
    const formatDateString = (dateStr) => {
        // 检查输入是否为 null 或 undefined
        if (dateStr == null) {
            return dateStr; // 或返回默认值，如空字符串 ''
        }

        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
            return dateStr.replace(/(\d{4})-(\d{2})-(\d{2})/, '$1年$2月$3日');
        }
        return dateStr;
    }
    
    const bank = async () => {
        window.history.go(-1);
    }

    return (
        <div>
            <div className="white-header van-nav-bar van-hairline--bottom" style={{ zIndex: '1', background: '#fff' }}>
                <div className="van-nav-bar__left">
                    <i className="van-icon van-icon-arrow-left van-nav-bar__arrow" onClick={bank} style={{ color: '#333' }}>

                    </i>

                </div>
                <div className="van-ellipsis van-nav-bar__title" style={{ color: '#333' }}>高等学籍
                </div>
                <div className="van-nav-bar__right">

                </div>

            </div>
            <div className="vote-part">
                <img style={{ width: '100%', marginTop: '10px' }} src={Math.floor(Math.random() * 3) + 1 == 1 ? img1 : Math.floor(Math.random() * 3) + 1 == 2 ? img2 : img3} alt="" />
            </div>
            <div className="padding16 xj-index">

                {/* <div class="jd-res-div" style={{ marginBottom: '0.533rem', display: dataSource.is_biye == 1 ? 'block' : 'none' }}>
                    <div class="flex-box">
                        <div class="flex1" style={{ textAlign: 'left' }}>
                            <span class="scan-txewm" >
                            </span>
                            <span style={{ color: '#333' }}>
                                查看图像采集码
                            </span>
                        </div>
                        <div class="arrow-right">
                            <i class="iconfont "></i>
                        </div>
                    </div>
                    <div class="sanjiao"><em></em><span></span></div></div> */}

                <div className="top-card">


                    <div className="van-row">
                        <div className="van-col van-col--9" >
                            <div className="flex-box" >
                                <div className="" >
                                    <div className="img-div">
                                        <img src={`${path}${status ? dataSource.luqu_avatar : dataSource.thr_luqu_avatar}`} className="full-img" />
                                        <p className="text">录取照片
                                        </p>
                                    </div>
                                </div>
                                <div className="" style={{ marginLeft: '8px' }}>
                                    <div className="img-div">
                                        <img src={`${path}${status ? dataSource.avatar : dataSource.thr_avatar}`} style={{ display: dataSource.is_biye == 0 ? 'none' : 'inline-block' }} className="full-img" />
                                        <img src={xlbj} style={{ display: dataSource.is_biye == 0 ? 'inline-block' : 'none' }} className="full-img" />
                                        <span style={{ display: dataSource.is_biye == 0 ? 'inline-block' : 'none' }} class="red-tips-icon"></span>
                                        <p className="text">学历照片
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="van-col van-col--15"><h5 className="namtFamily">{dataSource.username}
                        </h5>
                            <p className='namtFamily'>
                                <span>{dataSource.gender == 0 ? '女' : '男'}</span>&emsp;
                                <span>{dataSource.birthday}</span>
                            </p>
                        </div>
                    </div>
                    <div className="top-bottom-img xj-detail-img">
                        <p className='school'>
                            <span className='school-name'>{status ? dataSource.school_name : dataSource.thr_school_name}</span>
                            <span className='xueli-level1'>{status ? dataSource.xueli_level : dataSource.thr_xueli_level}</span>
                        </p>
                        <p className='zhuanye'>
                            <span>{status ? dataSource.zhuanye : dataSource.thr_zhuanye} &nbsp; | &nbsp; </span>
                            <span>{status ? dataSource.xingshi : dataSource.thr_xingshi}</span>
                        </p>

                    </div>
                </div>
                <div className="xj-c" >

                    <div style={{ marginTop: '30px' }}><div className='l-text'>民族</div> <div className='r-text'>{dataSource.mingzu}</div></div>
                    <div><div className='l-text'>证件号码</div> <div className='r-text'>{dataSource.id_number}</div></div>
                    <div><div className='l-text'>学制</div> <div className='r-text'>{status ? dataSource.xuezhi : dataSource.thr_xuezhi}</div></div>
                    <div><div className='l-text'>学历类别</div> <div className='r-text'>{status ? dataSource.category : dataSource.thr_category}</div></div>
                    <div><div className='l-text'>分院</div> <div className='r-text'>{status ? dataSource.fenyuan : dataSource.thr_fenyuan}</div></div>
                    <div><div className='l-text'>系所</div> <div className='r-text'>{status ? dataSource.xisuo : dataSource.thr_xisuo}</div></div>
                    <div><div className='l-text'>班级</div> <div className='r-text'>{status ? dataSource.class : dataSource.thr_class}</div></div>
                    <div><div className='l-text'>学号</div> <div className='r-text'>{status ? dataSource.xuehao : dataSource.thr_xuehao}</div></div>
                    <div><div className='l-text'>入学日期</div> <div className='r-text'>{status ? formatDateString(dataSource.enrollment_time) : formatDateString(dataSource.thr_enrollment_time)}</div></div>

                    <div><div className='l-text'>学籍状态</div> <div className='r-text'>{status ? (dataSource.is_biye == 0 ? '在籍（注册学籍）' : '不在籍（毕业）') : (dataSource.thr_is_biye == 0 ? '在籍（注册学籍）' : '不在籍（毕业）')}</div></div>
                    <div style={{ display: status ? (dataSource.is_biye == 0 ? '' : 'none') : (dataSource.thr_is_biye == 0 ? '' : 'none') }}>
                        <div className='l-text' >预计毕业日期</div> <div className='r-text'>{status ? formatDateString(dataSource.graduation_time) : formatDateString(dataSource.thr_graduation_time)}</div>
                    </div>


                    <div style={{ display: status ? (dataSource.is_biye == 0 ? 'none' : '') : (dataSource.thr_is_biye == 0 ? 'none' : '') }}>
                        <div className='l-text' >离校日期</div>    <div className='r-text'>{status ? formatDateString(dataSource.graduation_time) : formatDateString(dataSource.thr_graduation_time)}</div>
                    </div>

                </div>
                <div className="van-row" style={{ marginTop: '30px' }}>
                    <div className="van-col van-col--24">
                        <a>
                            <button className="my-btn van-button van-button--primary van-button--normal" onClick={() => {
                                window.localStorage.setItem('type', 'xj'); 
                                // if (status) {
                                //     window.localStorage.removeItem('status');

                                // } else {
                                    window.localStorage.setItem('status', 'threexj');
                                // }
								// 获取当前时间并添加一个月
								const now = new Date();
								now.setMonth(now.getMonth() + 1);
								
								// 格式化为 YYYY-MM-DD
								const year = now.getFullYear();
								const month = String(now.getMonth() + 1).padStart(2, '0');
								const day = String(now.getDate()).padStart(2, '0');
								const futureDate = `${year}-${month}-${day}`;
								
								window.localStorage.setItem('expiryDate', futureDate);
								window.location.href = '/gdjy/ReportIndex'
                            }}>
                                <span className="van-button__text">查看验证报告
                                </span>
                            </button>
                        </a>
                    </div>
                </div>
            </div>




        </div >
    )
};